import { type SerializeOptions, parse, serialize } from 'cookie'

type CookieValue = string | number | boolean | object

export function setCookieValue(key: string, value: CookieValue, options?: SerializeOptions): void {
  if (typeof document === 'undefined') {
    throw new Error('setCookieValue can only be used on the client.')
  }

  const serializedCookie = serialize(key, JSON.stringify(value), {
    path: '/',
    ...options,
  })
  document.cookie = serializedCookie
}

export function getCookieValue(key: string, request?: Request): string | null {
  if (typeof document !== 'undefined') {
    const cookies = parse(document.cookie)
    return cookies[key] || null
  }

  if (request) {
    const cookieHeader = request.headers.get('cookie') || ''
    const cookies = parse(cookieHeader)
    return cookies[key] || null
  }

  throw new Error('getCookieValue requires a `request` parameter on the server.')
}
